"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findFirstTile = exports.getRandomFloor = exports.convertJtoY = exports.convertItoX = exports.convertIIJtoXY = exports.convertIJtoXY = exports.convertSXtoI = exports.convertSYtoJ = exports.convertYtoJ = exports.convertXtoI = exports.getIJAtMouse = exports.getSafeOffset = exports.getSafeXY = exports.getSafeIJ = exports.getSafe = exports.getUnsafe = exports.inRange = exports.clearTo = exports.clear = exports.setupNeighbors = exports.setSize = exports.getSize = exports.create = exports.spotSize = void 0;
var assert_sidecar_1 = require("@lib/assert-sidecar");
var rando_sidecar_1 = require("@lib/rando-sidecar");
var common_sidecar_1 = require("@main/common-sidecar");
var voyageCamera_sidecar_1 = require("@voyage/camera/voyageCamera-sidecar");
var diveTileData_1 = require("./diveTileData");
var diveTileData_sidecar_1 = require("./diveTileData-sidecar");
var diveTilemapPart_1 = require("./diveTilemapPart");
var diveTilemapPart_sidecar_1 = require("./diveTilemapPart-sidecar");
exports.spotSize = 10 * 4; // * 0.99 // Do we need a small overlap to fix render gaps?
function create(w, h) {
    var obj = {
        parts: [],
        width: 0,
        height: 0,
    };
    setSize(obj, w, h);
    clear(obj);
    return obj;
}
exports.create = create;
function getSize(obj) {
    return [obj.width, obj.height];
}
exports.getSize = getSize;
function setSize(obj, width, height) {
    obj.width = width;
    obj.height = height;
    obj.parts = [];
    // TODO: kill existing?
    for (var j = 0; j < height; j++) {
        for (var i = 0; i < width; i++) {
            var gs = diveTilemapPart_sidecar_1.diveTilemapPart.create(i, j, i * exports.spotSize + exports.spotSize / 2, j * exports.spotSize + exports.spotSize / 2);
            obj.parts.push(gs);
        }
    }
    setupNeighbors(obj);
}
exports.setSize = setSize;
function setupNeighbors(obj) {
    var height = obj.height;
    var width = obj.width;
    var dirs = diveTilemapPart_1.neighborOffsets;
    for (var j = 0; j < height; j++) {
        for (var i = 0; i < width; i++) {
            var gs = getUnsafe(obj, i, j);
            for (var iOffset = 0; iOffset < dirs.length; iOffset++) {
                var gs2 = getSafeOffset(obj, { i: i, j: j }, dirs[iOffset][0], dirs[iOffset][1]);
                if (gs2) {
                    gs.neighbors[iOffset] = gs2;
                }
                else {
                    gs.neighbors[iOffset] = null;
                }
            }
        }
    }
}
exports.setupNeighbors = setupNeighbors;
function clear(obj) {
    var _clearTo = diveTileData_sidecar_1.diveTileData.get(diveTileData_1.EDiveTile.Acid);
    clearTo(obj, _clearTo);
}
exports.clear = clear;
function clearTo(obj, clearTo) {
    var tiles = obj.parts;
    for (var iTile = 0; iTile < tiles.length; iTile++) {
        var gs = tiles[iTile];
        diveTilemapPart_sidecar_1.diveTilemapPart.setTile(gs, clearTo);
        // Clear any hints and pathfinding helpers
        gs.visibilityIdx = -1;
        gs.gen_doorHint = '';
        // TODO: any other clearing
    }
}
exports.clearTo = clearTo;
function inRange(obj, i, j) {
    return i >= 0 && i < obj.width && j >= 0 && j < obj.height;
}
exports.inRange = inRange;
function getUnsafe(obj, i, j) {
    assert_sidecar_1.assert.t(inRange(obj, i, j), 'not in range', i, j);
    return obj.parts[i + j * obj.width];
}
exports.getUnsafe = getUnsafe;
function getSafe(obj, i, j) {
    if (!inRange(obj, i, j)) {
        return null;
    }
    return obj.parts[i + j * obj.width];
}
exports.getSafe = getSafe;
function getSafeIJ(obj, iij) {
    return getSafe(obj, iij.i, iij.j);
}
exports.getSafeIJ = getSafeIJ;
function getSafeXY(obj, ixy) {
    var i = convertXtoI(ixy.x);
    var j = convertYtoJ(ixy.y);
    return getSafe(obj, i, j);
}
exports.getSafeXY = getSafeXY;
function getSafeOffset(obj, iij, oi, oj) {
    return getSafe(obj, iij.i + oi, iij.j + oj);
}
exports.getSafeOffset = getSafeOffset;
function getIJAtMouse() {
    var s = common_sidecar_1.common.getPhaserScene();
    var mx = s.input.mousePointer.x;
    var my = s.input.mousePointer.y;
    var i = convertSXtoI(mx);
    var j = convertSYtoJ(my);
    return { i: i, j: j };
}
exports.getIJAtMouse = getIJAtMouse;
function convertXtoI(_x) {
    var i = Math.floor(_x / exports.spotSize);
    return i;
}
exports.convertXtoI = convertXtoI;
function convertYtoJ(_y) {
    var j = Math.floor(_y / exports.spotSize);
    return j;
}
exports.convertYtoJ = convertYtoJ;
function convertSYtoJ(_y) {
    var cam = voyageCamera_sidecar_1.voyageCamera.get();
    var zoom = voyageCamera_sidecar_1.voyageCamera.getZoom();
    var cy = _y / zoom + cam.cameraY / zoom;
    var j = Math.floor(cy / exports.spotSize);
    return j;
}
exports.convertSYtoJ = convertSYtoJ;
function convertSXtoI(_x) {
    var cam = voyageCamera_sidecar_1.voyageCamera.get();
    var zoom = voyageCamera_sidecar_1.voyageCamera.getZoom();
    var cx = _x / zoom + cam.cameraX / zoom;
    var i = Math.floor(cx / exports.spotSize);
    return i;
}
exports.convertSXtoI = convertSXtoI;
function convertIJtoXY(i, j) {
    var x = convertItoX(i);
    var y = convertJtoY(j);
    return { x: x, y: y };
}
exports.convertIJtoXY = convertIJtoXY;
function convertIIJtoXY(l) {
    var x = convertItoX(l.i);
    var y = convertJtoY(l.j);
    return { x: x, y: y };
}
exports.convertIIJtoXY = convertIIJtoXY;
function convertItoX(i) {
    var x = i * exports.spotSize + exports.spotSize / 2;
    return x;
}
exports.convertItoX = convertItoX;
function convertJtoY(j) {
    var y = j * exports.spotSize + exports.spotSize / 2;
    return y;
}
exports.convertJtoY = convertJtoY;
function getRandomFloor(obj) {
    var options = [];
    var tiles = obj.parts;
    for (var iTile = 0; iTile < tiles.length; iTile++) {
        var gs = tiles[iTile];
        if (gs.tile1.type === diveTileData_1.EDiveTile.Floor) {
            options.push(gs);
        }
    }
    return rando_sidecar_1.rando.sample(options);
}
exports.getRandomFloor = getRandomFloor;
function findFirstTile(obj, filter) {
    var tiles = obj.parts;
    for (var iTile = 0; iTile < tiles.length; iTile++) {
        var gs = tiles[iTile];
        if (filter(gs)) {
            return gs;
        }
    }
    return null;
}
exports.findFirstTile = findFirstTile;
